import type { GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult } from "./types";

export function isGetAppsAppGroupIdUserImportsImportIdScanEventNamesResult(
  value: unknown
): value is GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const object = value as Record<string, unknown>;
  return Array.isArray(object.event_names) && object.event_names.every((entry) => typeof entry === "string");
}
